const mEditionAcademyConfiguration = {
  mEditionAcademyConfiguration: {
    alerts: {
      updateAcademia: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'La configuración de academia fue actualizada exitosamente.'
      }
    },

    fieldsets: {
      steps: {
        first: '1. Configuración de Acceso',
        second: '2. Configuración de Apariencia'
      }
    },

    inputs: {
      categoria: {
        label: 'Categoría de Academia'
      },

      color: {
        label: 'Color específico'
      },

      multicolor: {
        label: 'Multicolor'
      },

      nombre: {
        label: 'Nombre de Academia',
        message: '* De 5 a 60 caracteres',
        placeholder: 'Mi Fantástica Academia'
      },

      url: {
        label: 'Url de Academia',
        message: '* De 3 a 120 caracteres',
        messageWarning: 'Al editar la url de tu academia deberás enviar el nuevo enlace a los alumnos ya inscriptos',
        placeholder: 'mi-fantastica-academia'
      }
    },

    validation: {
      categoria: {
        required: 'Categoría de academia es requerida.'
      },

      nombre: {
        maxLength: 'La longitud máxima permitida es de 60 caracteres.',
        minLength: 'La longitud mínima permitida es de 5 caracteres.',
        required: 'Nombre de academia es requerido. De 5 a 60 caracteres.'
      },

      url: {
        maxLength: 'La longitud máxima permitida es de 120 caracteres.',
        minLength: 'La longitud mínima permitida es de 3 caracteres.',
        required: 'Url de academia es requerida. De 3 a 120 caracteres.'
      }
    }
  }
}

export default mEditionAcademyConfiguration
